import React from "react";
import { Link } from "react-router-dom";
import { FundleLogo } from "./Brand";

export default function Footer() {
    return (
        <footer className="mt-20 bg-[#0b1437] text-white">
            <div className="max-w-[1400px] mx-auto px-6 py-12 grid md:grid-cols-5 gap-8">
                <div className="md:col-span-2">
                    <FundleLogo className="h-9" dark />
                    <p className="text-[#4b5563] text-sm mt-4 max-w-sm">
                        Gift happiness, rewarded. India's premium loyalty & gift card marketplace — 270+ trusted brands, instant delivery, points + cash.
                    </p>
                    <a href="https://wa.me/918072905306?text=Hi" target="_blank" rel="noreferrer" className="fx-btn-gold !text-sm mt-5 inline-flex">
                        💬 Join on WhatsApp
                    </a>
                </div>
                <FooterCol title="Shop">
                    <Link to="/category/all" className="hover:text-[#c9a959]">All deals</Link>
                    <Link to="/category/Apparel" className="hover:text-[#c9a959]">Apparel</Link>
                    <Link to="/category/Jewellery" className="hover:text-[#c9a959]">Jewellery</Link>
                    <Link to="/category/Electronics" className="hover:text-[#c9a959]">Electronics</Link>
                    <Link to="/category/Hotels" className="hover:text-[#c9a959]">Hotels</Link>
                </FooterCol>
                <FooterCol title="Earn & Redeem">
                    <Link to="/account/scan" className="hover:text-[#c9a959]">Scan a bill</Link>
                    <Link to="/account/wallet" className="hover:text-[#c9a959]">My wallet</Link>
                    <Link to="/account/vouchers" className="hover:text-[#c9a959]">My vouchers</Link>
                    <Link to="/login" className="hover:text-[#c9a959]">Sign in</Link>
                </FooterCol>
                <FooterCol title="Company">
                    <a className="hover:text-[#c9a959]" href="mailto:support@fundle.ai">Support</a>
                    <Link to="/admin/login" className="hover:text-[#c9a959]">Admin</Link>
                </FooterCol>
            </div>
            <div className="border-t border-white/10 py-5">
                <div className="max-w-[1400px] mx-auto px-6 flex flex-col md:flex-row gap-3 justify-between items-center text-xs text-[#9ca3af]">
                    <p>© 2026 Fundle Experiences Pvt Ltd · Made in India for India</p>
                    <p>AI bill scanning · Razorpay secure payments · WhatsApp engine</p>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, children }) {
    return (
        <div className="text-sm">
            <p className="text-xs uppercase tracking-[0.25em] text-[#c9a959] mb-3">{title}</p>
            <div className="flex flex-col gap-2 text-white/75">{children}</div>
        </div>
    );
}
